/** 
 * ACTION-MENU
 * Context-menu with list of choices
 */
import { faChevronLeft, faChevronRight, faTimes, IconDefinition } from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import ContextMenu from "./context-menu";
import { toast } from "react-toastify"
import ListItem from "./list-item";
import { WithTranslation, withTranslation } from "react-i18next";
import { useState } from "react";
import Space from "./space";
import ListButton from "./list-button";
import renderBold from "@/utils/render-bold.utils";

interface ActionState{
  icon : IconDefinition
  id : string
  isAdvanced? : boolean
  isInactive? : boolean
  label : string,
  color? : "red" | "orange" //Urgency : red blocks, orange is a warning
  isDismissable? : boolean //Can be removed from the list by the user (onDismiss)
  description? : string //Detail displayed under the label (label is then in bold)
}

interface OwnProps extends WithTranslation{
  actions : ActionState[] //Actions possibles (menu contextuel)
  positionBottom? : boolean
  positionRight? : boolean
  title? : string //Light title on top of the menu
  maxHeight? : number //Max height (px) : the list scrolls beyond
  width? : number //Custom width (px)
  onSelect : Function //Clic sur bouton d'action
  onClose : Function //Action au clic
  onDismiss? : Function //Remove an action that is dismissable
}

function ActionsMenu(props:OwnProps) {
  const { t } = props

  const [showAdvanced, setShowAdvanced] = useState(false)
  const [actions, setActions] = useState(props.actions?.filter(x => !x.isAdvanced))

  function select(e, action){
    e.stopPropagation()
    if (!action.isInactive){
      props.onSelect(action.id)
      close()
    }else{
      toast(t("action_unauthorized"), { type : 'error' })
    }
  }

  function close(){
    props.onClose()
  }

  //Show advanced options
  function toogleAdvanced(e){
    e.stopPropagation()

    if (showAdvanced){
      setActions(props.actions?.filter(x => !x.isAdvanced))
    }else{
      setActions(props.actions?.filter(x => x.isAdvanced))
    }

    setShowAdvanced(!showAdvanced)

  }
  
  return (
    <ContextMenu onClose={close}
      positionBottom={props.positionBottom}
      positionRight={props.positionRight}
      maxHeight={props.maxHeight}
      width={props.width}>
       
      { props.title &&
      <div className="grey-t text-sm" style={{ padding : '10px 16px' }}>{props.title}</div>
      }

      { actions.map(action => 
      <ListItem key={action.id}
        className={action.color === "red" ? "setup-card-alert-error" : action.color === "orange" ? "setup-card-alert-warning" : undefined}
        isEditable 
        isSmall
        onClick={(e) => select(e, action)}>

        <span className={"flex w-full items-center" + (action.isInactive ? " grey-t" : "")}>
          <FontAwesomeIcon icon={action.icon}
            className="shrink-0"
            style={{ marginRight : action.description ? '16px' : '8px', width : '18px' }}/>
          <div className={action.description ? 'py-1.5' : ''}>
            {action.description ? <b>{action.label}</b> : action.label}
            {action.description && <div className={(action.color ? "" : "grey-t ") + "text-sm"}>{renderBold(action.description)}</div>}
          </div>
          {action.isDismissable && props.onDismiss && (
            <>
              <Space/>
              <span className="-mr-3 ml-2 shrink-0">
                <ListButton icon={faTimes} isSmall text={t("utils_ignore")} tooltipPosition="left"
                  onClick={() => props.onDismiss?.(action.id)}/>
              </span>
            </>
          )}
        </span>

      </ListItem>
      )
      }

      { /** button show more or less */
      props.actions?.filter(x => x.isAdvanced).length > 1 && 
      <div>
        { showAdvanced
        ?
        <ListItem  isEditable
          onClick={toogleAdvanced}>
          {t("utils_back")}
          <Space/>
          <FontAwesomeIcon icon={faChevronLeft} style={{ margin : 'auto -12px auto 0px' }}/>
        </ListItem>
        :
        <ListItem  isEditable
          onClick={toogleAdvanced}>
          {t("utils_show_more_options")}
          <Space/>
          <FontAwesomeIcon icon={faChevronRight} style={{ margin : 'auto -12px auto 0px' }}/>
        </ListItem>
        }
      </div>
      }

    </ContextMenu>
  )

}

export default withTranslation()(ActionsMenu)